import { Model } from 'pinia-orm';
import Organization from './Organization';
import User from './User';
import { AccountStatus } from '@/enums/AccountStatus.enum.js';
import OrderBox from '@/models/commerce/OrderBox.js';

export default class ClubMembership extends Model {
  static entity = 'clubMemberships';

  static fields() {
    return {
      id: this.uid(),
      code: this.attr(''),
      ownerName: this.attr(''),
      status: this.attr(''),
      role: this.attr(''),
      isApproved: this.attr(false),
      initialPoolShare: this.attr(0),
      joinedAt: this.attr(null),
      expiresAt: this.attr(null),
      membershipStatus: this.attr(null),     // NEW — presenter from backend P2-A; null until backend ships
      createdAt: this.attr(''),
      updatedAt: this.attr(''),
      organizationId: this.attr(null),
      clubId: this.attr(null),

      user: this.belongsTo(User, 'userId'),
      organization: this.belongsTo(Organization, 'organizationId'),
      orderBoxes: this.hasMany(OrderBox, 'memberId'),
    };
  }

  // Get full name of the user.
  get memberShipStatus() {
    return this.isAuthenticated ? this.code ? 'Active' : 'Pending' : 'Guest';
  }
  get statuss() {
    return Object.keys(AccountStatus).find(key => AccountStatus[key] === this.status) ;
  }
}
